import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { PCOR_QUALITY_MEASURE, PCOR_FILTER_TIN } from './apiURLConstants';

const _httpService = new HttpService();
const cache = new Map();

if(checkIsInternal()){
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}
else{
 _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}


export const getPcorQualityMeasureData = async (payload: any) => {
    const url = PCOR_QUALITY_MEASURE;
    try {
        const response: any = await _httpService.push(url, payload);
        return response;
    } catch (error) {
        console.error('API call Failed: ', error);
        return null;
    }
};

export const getPcorFilterTinData = async (payload: any) => {
    const cacheKey = `pcor_filter_${JSON.stringify(payload)}`;
    if (cache.has(cacheKey)) {
      return cache.get(cacheKey);
    }
    try {
        const response: any = await _httpService.push(PCOR_FILTER_TIN, payload);
        cache.set(cacheKey, response);
        return response;
    } catch (error) {
        console.error('PCOR Filter API call Failed: ', error);
        return null;
    }
};